import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-upgrade-to-plan',
    templateUrl: './upgrade-to-plan.component.html',
    styleUrls: ['./upgrade-to-plan.component.scss'],
    standalone: false
})
export class UpgradeToPlanComponent implements OnInit {
  upgradeType: 'pro' | 'enterprise' = 'pro';
  data: any;

  constructor(
     public modalRef: BsModalRef,
     private route: Router
  ) { }

  ngOnInit(): void {
    this.upgradeType = this.data?.type || 'pro'; // Default to 'pro' if not provided
    console.log('UpgradeToPlanComponent initialized with upgradeType:', this.data);
  }
  goToBilling(){
    this.route.navigate(['dashboard/setup/licenseBilling'])
    this.modalRef.hide(); 
  }

}
